<template>
  <default-dialog v-model="enabled" :name="`Criar novo ${typeStr}`">
    <template slot="rightButton">
      <v-btn @click="submit" :loading="submitting" text>Salvar</v-btn>
    </template>
    <v-form class="pa-1" ref="form" v-model="valid">
      <v-layout class="pa-2">
        <div class="my-auto" style="width: 100px; margin-left: 10px; margin-right: 0px">
          <v-layout column align-center justify-center fill-height>
            <input
              id="creatorFileInput"
              type="file"
              accept="image/png, image/jpeg"
              @change="didChangeFile"
            />
            <v-avatar size="80" style="cursor: pointer" @click.stop="didTapFileInput()">
              <v-img
                id="creatorPreviewImage"
                ref="creatorPreviewImage"
                :src="previewFile || '/img/profile-default.jpg'"
                class="elevation-2"
              />
            </v-avatar>
            <v-btn small text color="primary" @click.stop="didTapFileInput()">
              Trocar
              <v-icon x-small>camera_alt</v-icon>
            </v-btn>
          </v-layout>
        </div>
        <div class="ml-2 mt-4" style="width: 100%">
          <v-text-field
            class="my-auto"
            v-model="name"
            :rules="[formRules.required]"
            :error-messages="nameErrorMessage"
            required
            hide-details="auto"
            label="Nome"
          />
        </div>
      </v-layout>
    </v-form>
    <upload-dialogs
      :is-uploading="uploading"
      :upload-progress="progress"
      :show-snackbar="snackbar"
      :upload-name="uploadName"
      :upload-size="uploadSize"
      @hideSnackbar="snackbar = false"
      @didTapCancel="didTapCancel"
    />
  </default-dialog>
</template>

<script>
import { createCreatorWithContent } from "@/firebase/api/creator";
import CreatorForm from "@/mixins/creatorForm.js"

export default {
  mixins: [CreatorForm],
  methods: {
    evaluateCreatorExistence(thisIsANewCreator) {
      return  this.submitting || thisIsANewCreator ? "" : this.creatorAlreadyExistsError;
    },

    updateDatabase() {
      this.createCreator({ name: this.name }, this.type);
    },
    beforeUpdateCreator() {
      this.uploading = false;
      this.file = null;
      this.previewFile = null;
      this.snackbar = true;
      this.progress = 0;
    },
    async createCreator(creator) {
      this.creatorID = await createCreatorWithContent(
        creator,
        this.$route.params.chapterID,
        this.$route.params.contentID,
        this.type
      );
      if (this.previewFile) {
        this.setupUpload();
      } else {
        this.closeForm();
      }
    },

  }
};
</script>